module.exports = require('react/lib/ReactFragment').create;


/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/react-addons-create-fragment/index.js
 ** module id = 209
 ** module chunks = 0
 **/